import { Validators } from '@angular/forms';
import { TableCols } from '../interfaces/static-data';
import { YES_NO } from 'src/app/product-capture/model/consts/yes-no.const';

export const DATA_EXPORT_FORMATS: TableCols[] = [
  {
    key: 'rank',
    displayValue: 'Rank',
    validators: [Validators.required],
  },
  {
    key: 'formatName',
    displayValue: 'Format Name',
    validators: [Validators.required],
  },
  {
    key: 'enabled',
    displayValue: 'Enabled',
    validators: [Validators.required],
    type: 'select',
    items: YES_NO,
  },
  {
    key: 'integratorName',
    displayValue: 'Integrator Name',
  },
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  }
];
